import { gql } from '@apollo/client';

export const GET_PRODUCT_INFO_FOR_REVIEWS = gql`
  query getProduct($slug: String) {
    product: getProduct(slug: $slug) {
      id
      name
      images {
        sort_order
        url
      }
    }
  }
`;

export const GET_PRODUCT_REVIEWS = gql`
  query getProductReviews(
    $id: Int
    $slug: String
    $sortBy: String
    $offset: Int
    $limit: Int
  ) {
    productReviews: getProductReviews(
      id: $id
      slug: $slug
      sortBy: $sortBy
      offset: $offset
      limit: $limit
    ) {
      totalReviews
      averageRating
      reviews {
        id
        date
        rate
        title
        comment
        full_name
        location
      }
    }
  }
`;

export const GET_PRODUCT_REVIEWS_META = gql`
  query getProductReviews(
    $slug: String
    $sortBy: String
    $offset: Int
    $limit: Int
  ) {
    productReviewsMeta: getProductReviews(
      slug: $slug
      sortBy: $sortBy
      offset: $offset
      limit: $limit
    ) {
      totalReviews
      averageRating
    }
  }
`;
